(function () {
  function init(root) {
    if (root.dataset.lisaQuickReady === '1') return;
    root.dataset.lisaQuickReady = '1';
    var form = root.querySelector('.lisa-quick-order__form');
    if (!form) return;
    var inputs = Array.prototype.slice.call(form.querySelectorAll('.lisa-quick-order__qty'));
    var summary = form.querySelector('[data-lisa-quick-order-summary]');
    var error = form.querySelector('[data-lisa-quick-order-error]');
    var button = form.querySelector('.lisa-quick-order__submit');
    var busy = false;
    var currency = root.dataset.currency || 'USD';
    var formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }); }
    catch (e) { formatter = { format: function (value) { return value.toFixed(2) + ' ' + currency; } }; }

    function collect() {
      var items = [], units = 0, total = 0, issue = '';
      inputs.forEach(function (input) {
        var raw = input.value.trim();
        if (!raw) return;
        var quantity = Number(raw);
        var min = Number(input.dataset.min) || 1;
        var increment = Number(input.dataset.increment) || 1;
        var max = Number(input.dataset.max) || 0;
        if (!Number.isSafeInteger(quantity) || quantity < 0) { issue = 'Enter a valid whole-number quantity.'; return; }
        if (quantity === 0) return;
        if (quantity < min || (quantity - min) % increment !== 0 || (max > 0 && quantity > max)) {
          issue = 'Adjust quantities to match the minimum, increment, and maximum order rules.';
          return;
        }
        items.push({ id: Number(input.dataset.variantId), quantity: quantity });
        units += quantity;
        total += Number(input.dataset.price) * quantity;
      });
      return { items: items, units: units, total: total, issue: issue };
    }
    function refresh() {
      var selected = collect();
      summary.textContent = selected.units + (selected.units === 1 ? ' unit' : ' units') + ' selected · ' + formatter.format(selected.total / 100);
      if (selected.issue) { error.hidden = false; error.textContent = selected.issue; }
      else { error.hidden = true; error.textContent = ''; }
      button.disabled = busy || selected.items.length === 0 || Boolean(selected.issue);
    }
    form.addEventListener('input', refresh);
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy) return;
      var selected = collect();
      if (selected.issue || !selected.items.length) { refresh(); return; }
      busy = true;
      button.textContent = 'Adding…';
      refresh();
      try {
        var response = await fetch(root.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: selected.items })
        });
        if (!response.ok) {
          var result = await response.json().catch(function () { return {}; });
          throw new Error(result.description || result.message || 'Could not add items to cart.');
        }
        window.location.assign(root.dataset.cartUrl || '/cart');
      } catch (e) {
        error.hidden = false;
        error.textContent = e.message || 'Could not add items. Please try again.';
        busy = false;
        button.textContent = 'Add selected to cart';
        button.disabled = false;
      }
    });
    refresh();
  }
  function initAll() { document.querySelectorAll('[data-lisa-quick-order]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (!window.__lisaQuickOrderSectionListener) {
    window.__lisaQuickOrderSectionListener = true;
    document.addEventListener('shopify:section:load', initAll);
  }
})();